module.exports = __webpack_public_path__ + "images/ico-userblue-act.svg?bfdd84f69ede36b566c12e4ee5440f0e";